import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-b-0" data-id="element-287">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-5 flex items-center justify-between text-left hover:text-orange-600 transition-colors" data-id="element-288">
        <span className="font-medium text-lg text-navy-900" data-id="element-289">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-290">
          <ChevronDownIcon className="w-5 h-5 text-orange-600 flex-shrink-0" data-id="element-291" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-292">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2,
        ease: 'easeInOut'
      }} data-id="element-293">
            <p className="pb-5 text-gray-700 leading-relaxed" data-id="element-294">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}